export default __webpack_public_path__ + "static/media/EstacoesIconFinish.6a540146.svg";